import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const WsCtx = createContext(null);

export function WorkspaceProvider({ children }) {
  const [list, setList] = useState(null);
  const [wid, setWid] = useState(localStorage.getItem("pp_ws"));

  const reload = useCallback(async () => {
    const { data } = await api.get("/workspaces");
    setList(data);
    setWid((cur) => (data.find((w) => w.id === cur) ? cur : data[0]?.id || null));
    return data;
  }, []);

  useEffect(() => {
    reload().catch(() => setList([]));
  }, [reload]);

  useEffect(() => {
    if (wid) localStorage.setItem("pp_ws", wid);
  }, [wid]);

  const ws = list?.find((w) => w.id === wid) || null;
  return <WsCtx.Provider value={{ list, ws, wid, setWid, reload }}>{children}</WsCtx.Provider>;
}

export const useWs = () => useContext(WsCtx);
